export const googleConfig = {
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    callback: ( response ) => response,
}